export class TimeoutError extends Error {
  name = "TimeoutError";
}
